import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';
import axios from 'axios';
import Configdata from './Defaultdata';
import './home.css';
import Localdata from './Localdata';
import './cube.css';
import { tblrows,getmessage,sendpostnow } from './Dynamictable';
import Usersession from './Usersession';
import {showhidediv,hdactinf,insertpost} from './userdefaultdata';
import {actptnr} from './Uactingwithprtnr';

export default class Viewuseractivities extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "chat";
	
  	}
	
    state = {

	
        name: "world chat",
       respdata: null,   
       url: "",
       tblheaders:[''],		
       tblrows: [{id:1, nm: 'c',sts:0}],	
       
       tblfiterdata: [{"aid":0,"actid":0,"acttp": 0,"sendid": 0,"rcvid":0,"sr":0,nm:''}]
 	
    };

    
   
    
	
   
  
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
        debugger;
	
        const pid = localStorage.getItem("id");
        
        this.setserverurl();
        const ar = [{id:1, nm: 'c',sts:0},{id:2, nm: 'd',sts:0}]
	
	const cols = ["Activities"];
        this.setState({ tblheaders: cols });
	this.setState({ tblrows: ar});
        const code = Usersession.getUserId(); 
        this.getpostdata(code);

    }
 getpostdata(eid: any){
	 try {
          const url = "/getactivitybyuser?prd=" + eid;
	//alert(url);	
	axios.get(Configdata.srvurl + url)
            .then((response: any) => {
               
		const tdata = response.data;
               // alert(tdata);
                if(tdata != 'NA')
		this.reducearray(tdata);
              
            })
            .catch((err: any) => {
                alert('Something went wrong');
                
            });

                
          }
        catch (e) {
            debugger;

        }

	
      	//e.preventDefault()


     }	

     reducearray(arr: any){
     let farr = [{}];
      if(arr){
         // alert(JSON.stringify(arr));
	     if(arr.length > 0){
		for(let i =0;i< arr.length;i++){
                
                 const rv = arr[i];
		

		 farr.push(rv);
		 
		}
	    }
	 }
	if(farr.length > 2){
         farr.shift();
	// farr.shift();
         
	}
        
	//alert(JSON.stringify(farr));
	this.setState({ tblfiterdata: farr});
	
      }	
displayact(e:any,id:any,daid:any){
         const pdv = document.getElementById('chactwithptnr') as HTMLElement; 
         const dv = document.getElementById('Activityplay') as HTMLElement;
     dv.style.display = 'block';
   pdv.style.display = 'block';
  
       const act = actptnr(id);
	ReactDOM.render(act,dv);

        const apiurl = "/deleteactivity";

    const obj = {aid:daid};
    insertpost(apiurl,obj);


}
 deleteactivity(e:any){
   const codewithexp = e.target.id;
    const code = codewithexp.split(',')[0];
    const apiurl = "/deleteactivity";

    const obj = {aid:code};
    insertpost(apiurl,obj);
  // alert(code);
  
   
 }   
 render() {

   
     return (

         <form>
	<div className="per100" id="lstact">
	 <div className="postingouterdiv" style={{overflowX:'hidden',overflowY:'auto',height:'45vh'}}>
	  <div className="postingtablediv">

	    <table className="postingtable">
		
		<thead>
		   <tr>	
			
			<th className="comptd" style={{width:'80%'}}>Activities</th>
			<th className="comptd" style={{width:'10%',backgroundColor:'blue',textAlign:'center'}}>X</th>
                        
			
		   </tr>	
		</thead>

		
		<tbody>
			{this.state.tblfiterdata.map((row,index)=>(
		<tr>
			<td className="comptd" style={{width:'80%'}}>
			  <a href="#" className="blanka" onClick={e => this.displayact(e,row.actid,row.aid)} >
				<span id={row.aid+","+'act'}>{row.nm}</span>
			   </a>
			</td>
			<td className="comptd" style={{width:'10%',backgroundColor:'blue',textAlign:'center'}}>
			  <a href="#" className="blanka" onClick={e => this.deleteactivity(e)} >
				<span id={row.aid+","+'act'}>X</span>
			   </a>
			</td>
		</tr>
			))}
		 </tbody>	
		
	   </table>
	 </div>		
	</div>
	
	</div>
   	</form>
    
   
      );
}
}

